export const TextWidget = (props) => {
    if(props.reverse === true){
        return(
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '90%', paddingTop: props.paddingTop}}>
                <p style={{fontWeight: 'bold', color: '#659767', margin: '0', fontSize: 'small'}}>{props.label}</p>
                <p style={{fontSize: 'x-large', margin: '2px 0 0 0'}}>{props.number} {props.unit}{props.unitMesure}</p>
            </div>
        )
    }
    return(
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: props.width ?? '90%'}}>
            <p style={{fontSize: 'x-large', margin: props.margin ?? '10px 0 0 0'}}>{props.number} {props.unit}{props.unitMesure}</p>
            <p style={{fontWeight: 'bold', color: '#659767', margin: '0', fontSize: 'small'}}>{props.label}</p>
        </div>
    )
};